module.exports = __webpack_public_path__ + "img/rca-rs-menu8.cb6a048d.jpg";